import React, { type ReactNode } from 'react';

import { FormattedMessage } from 'react-intl-next';
import { graphql, useFragment } from 'react-relay';

import { AtlasStatusLozenge } from '../../../../../../../common/ui/atlas-status-lozenge';
import { SearchMetadata } from '../../../../../../../common/ui/search-metadata';

import type { goalTitleMetadata_AtlassianSearchPage$key } from './__generated__/goalTitleMetadata_AtlassianSearchPage.graphql';
import { messages } from './messages';

interface GoalTitleMetadataProps {
	metadata: goalTitleMetadata_AtlassianSearchPage$key;
}

export const GoalTitleMetadata = ({ metadata }: GoalTitleMetadataProps): React.JSX.Element => {
	const data = useFragment(
		graphql`
			fragment goalTitleMetadata_AtlassianSearchPage on SearchResultAtlasGoal {
				goal {
					status {
						localizedLabel {
							messageId
						}
						value
						score
					}
					targetDate {
						label
					}
				}
			}
		`,
		metadata,
	);

	let statusLozenge: ReactNode | null = null;
	const messageKey = data.goal?.status?.localizedLabel?.messageId as keyof typeof messages;
	const statusLabel = messages[messageKey] ? <FormattedMessage {...messages[messageKey]} /> : null;
	const statusValue = data.goal?.status?.value;
	const statusScore = data.goal?.status?.score ?? null;
	const date = data.goal?.targetDate?.label;
	if (statusLabel && statusValue) {
		statusLozenge = (
			<AtlasStatusLozenge
				statusValue={statusValue}
				statusLabel={statusLabel}
				statusScore={statusScore}
				date={date}
			/>
		);
	}

	const titleMetadataParts: [string, ReactNode][] = [['status', statusLozenge]];

	return <SearchMetadata parts={titleMetadataParts} displaySpacer={false} />;
};
